<template>
  <card>
    <h4 slot="header" class="card-title">Edit Profile</h4>
    <form>
      <div class="row">
        <div class="col-md-5">
          <base-input type="text"
                    label="Name"
                    placeholder="Name"
                    v-model="form.name">
          </base-input>

        </div>
        <div class="col-md-3">
          <base-input type="email"
                    label="Email"
                    placeholder="Email"
                    v-model="form.email">
          </base-input>
        </div>
        <div class="col-md-4">
          <base-input v-if="isAdmin" type="text"
                    label="Company"
                    :disabled="true"
                    placeholder="Company"
                    v-model="form.company">
          </base-input>
          <base-input v-else type="text"
                    label="Outlet"
                    :disabled="true"
                    placeholder="Outlet"
                    v-model="form.outlet_name">
          </base-input>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <base-input type="text"
                    label="Address"
                    placeholder="Address"
                    :disabled="true"
                    v-model="form.address">
          </base-input>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <base-input type="text"
                    label="Password"
                    placeholder="Password"
                    v-model="form.password">
          </base-input>
        </div>
        <div class="col-md-6">
          <base-input type="text"
                    label="Confirm Password"
                    placeholder="Confirm Password"
                    v-model="form.confirm_password">
          </base-input>
        </div>
      </div>
      <div class="text-center">
        <button type="submit" class="btn btn-info btn-fill float-right" @click.prevent="updateProfile">
          Update Profile
        </button>
      </div>
      <div class="clearfix"></div>
    </form>
  </card>
</template>
<script>
  import Card from 'src/components/Cards/Card.vue'
  import { mapGetters } from 'vuex'
  import axios from '@/axios'
  export default {
    components: {
      Card
    },
    data () {
      return {
        roles: new Set(),
        form: {
          user_id: '',
          company: 'TOUCHPOINT',
          outlet: '',
          outlet_name: '',
          name: '',
          email: '',
          address: '',
          city: '',
          country: '',
          postalCode: '',
          aboutMe: '',
          password: '',
          confirm_password: ''
        },
        isAdmin: false
      }
    },
    computed: {
      ...mapGetters(["user"]),
    },
    created() {
      this.user.roles.forEach((r) => {
        this.roles.add(r.name);
      });
      this.user.outlet.forEach((outlet) => {
        if (outlet) {
          console.log('outlet', outlet);
          this.userHasOutlet = true;
          this.outlet = outlet;
          this.form.outlet_name = outlet.name;
          this.form.address = outlet.address;
        }
      });

      this.form.email = this.user.email;
      this.form.name = this.user.name;
      if (this.roles.has('superadmin')) {
        this.isAdmin = true;
        this.form.address = 'No. 2, 2nd Floor, 1st Cross, B. M. Kaval, New Baiyappanahalli Extn, Indiranagar, Bengalore'
      }
    },
    methods: {
      getUser() {

      },
      updateProfile () {
        // alert('Your data: ' + JSON.stringify(this.user))
        axios.post('/outlet/user/update', {
          user_id: this.user.id,
          name: this.form.name,
          email: this.form.email,
          password: this.form.password,
          password_confirmation: this.form.confirm_password
        }).then((res) => {
          console.log('user res =>', res.data);
          if (res.data.status === 200) {
            this.$notifications.notify({
                      message: res.data.message,
                      icon: 'nc-icon nc-check-2',
                          horizontalAlign: 'right',
                          verticalAlign: 'top',
                          type: 'success'
                  });
            setTimeout(() => {
              this.$router.push('/overview');
            }, 2000);
          }
        }).catch((error) => {
          console.log('error', error.response.data);
          if (error && error.response.data.status !== 200) {
                    for (const err in error.response.data.message) {
                        if (
                            Object.hasOwnProperty.call(
                                error.response.data.message,
                                err
                            )
                        ) {
                      // console.log('validation error', error.response.data.message[err][0]);

                          this.$notifications.notify({
                              message: error.response.data.message[err][0],
                              icon: 'nc-icon nc-notification-70',
                              horizontalAlign: 'right',
                              verticalAlign: 'top',
                              type: 'danger'
                            });
                        }
                    }
                }
        });
      }
    }
  }

</script>
<style>

</style>
